import { render } from "./SuspectView.vue?vue&type=template&id=c8f2b654"
import script from "./SuspectView.vue?vue&type=script&lang=js"
export * from "./SuspectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__